export default __webpack_public_path__ + "static/media/steak.61fe8093.svg";